import {Service} from "@/apiServices/Service";

export class CatalogosService extends Service {
    constructor() {
        super('catalogos/');
    }

    listaClinicasNombreId(){
        this.onStart();
        return this.http.get(this.getUrl(['getClinicas']))
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }


    listaClinicas(){
        this.onStart();
        return this.http.get(this.getUrl(['listaClinicas']))
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    listaPadecimientosOd() {
        this.onStart();
        return this.http.get(this.getUrl(['listaPadecimientosOd']))
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    listaDientesByIdTipoDentifion(idTipoDenticion) {
        this.onStart();
        return this.http
            .get(this.getUrl(['listaDientes','ordenados', idTipoDenticion]))
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    listaDientesAdultos() {
        this.onStart();
        return this.http
            .get(this.getUrl(['listaDientesAdulto']))
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    listaTiposPromocion() {
        this.onStart();
        return this.http
            .get(this.getUrl(['listaTipoPromocion']))
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    listaZonas() {
        this.onStart();
        return this.http
            .get(this.getUrl(['listaPrecios']))
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerEspecialidades() {
        this.onStart();
        return this.http
            .get(this.getUrl(['obtenerEspecialidades']))
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerTratamientosConEspecilidades() {
        this.onStart();
        return this.http
            .get(this.getUrl(['obtenerTratamientosConEspecilidades']))
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    listaDientesNino(){
        return this.listaDientesByIdTipoDentifion(1);
    }
    listaDientesAdulto(){
        return this.listaDientesByIdTipoDentifion(2);
    }
    listaDientesMixto(){
        return this.listaDientesByIdTipoDentifion(3);
    }

    obtenerMotivosRechazoPTI() {
        this.onStart();
        return this.http
            .get(this.getUrl(['obtenerRechazoPti']))
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerOrignes(){
        this.onStart();
        return this.http.get(this.getUrl(['canalorigen']))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })

    }

    estatusContactos(){
        this.onStart();
        return this.http.get(this.getUrl(['estatus', 'contactos']))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })

    }
    tipoPaciente(){
        this.onStart();
        return this.http.get(this.getUrl(['tipoPaciente']))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })

    }

    obtenerClasificaciones(idClasificacion){
        this.onStart();
        return this.http.post(this.getUrl(['clasificaciones']), idClasificacion)
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })

    }

    obtenerClasificacionesUsuario(){
        this.onStart();
        return this.http.get(this.getUrl(['clasificaciones','usuario']))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })

    }

    obtenerTratameintos(){
        this.onStart();
        return this.http.get(this.getUrl(['obtenerTratamientos']))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })

    }
    obtenerDientes(){
        this.onStart();
        return this.http.get(this.getUrl(['listaDientes']))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })

    }
    obtenerEstatusLlegadaPaquete(){
        this.onStart();
        return this.http.get(this.getUrl(['obtener','llegadas']))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })

    }
    obtenerDientesCero(){
        this.onStart();
        return this.http.get(this.getUrl(['obtener','dientes','ceros']))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })

    }
    obetenerPadecimientosPorDienteDescentralizados(params){
        this.onStart();
        return this.http.post(this.getUrl(['padecimientos','obtener','denticion','descentralizada']), params)
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })

    }

    obtenerTipoPaciente(){
        this.onStart();
        return this.http.get(this.getUrl(['tipo-paciente','activos']))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })

    }
    obtenerSubTipoPaciente(){
        this.onStart();
        return this.http.get(this.getUrl(['subtipo-paciente','activos']))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })

    }


}
